import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Layout } from "@/components/Layout";
import { ProductCard } from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function Wishlist() {
  const { user, wishlist } = useAuth();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    api.get("/wishlist").then(({ data }) => { setProducts(data); setLoading(false); });
  }, [user, wishlist]);

  return (
    <Layout>
      <div className="bg-blush py-14">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="eyebrow">Saved for later</p>
          <h1 className="mt-3 font-serif text-4xl lg:text-5xl text-charcoal">Your Wishlist</h1>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-12">
        {!user ? (
          <div className="text-center py-20">
            <p className="text-charcoal/60">Sign in to save your favourite pieces.</p>
            <Button asChild className="mt-6 bg-charcoal text-white rounded-none hover:bg-gold font-display">
              <Link to="/login" data-testid="wishlist-login-btn">Sign In</Link>
            </Button>
          </div>
        ) : loading ? (
          <p className="text-center text-charcoal/50 py-20">Loading…</p>
        ) : products.length === 0 ? (
          <div className="text-center py-20" data-testid="empty-wishlist">
            <p className="text-charcoal/60">Nothing saved yet — tap the heart on any piece you love.</p>
            <Button asChild className="mt-6 bg-charcoal text-white rounded-none hover:bg-gold font-display">
              <Link to="/shop">Browse the Boutique</Link>
            </Button>
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </Layout>
  );
}
